<template>
  <div>
    <base-icon name="under-construction"></base-icon>
  </div>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";
export default {
  name: "UnderConstruction",
  components: { BaseIcon },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      function startAnimation() {
        null == Interval && (Interval = setInterval(animate, 10));
      }
      function animate() {
        aniPoints += 1;

        if (aniPoints > 10 && aniPoints < 55) {
          endAnimation = false;
          fast_ += (2 - fast_) / 10;
          rot1_1 += (rot1_2 - rot1_1) / fast_;
          rot2_1 += (rot2_2 - rot2_1) / fast_;
          leaver_1.setAttribute("opacity", rot1_1);
          leaver_2.setAttribute("opacity", rot2_1);
        }

        if (aniPoints > 75 && aniPoints < 125) {
          endAnimation = false;
          fast_2 += (2 - fast_2) / 10;
          rot1_1 += (rot1_3 - rot1_1) / fast_2;
          rot2_1 += (rot2_3 - rot2_1) / fast_2;
          leaver_1.setAttribute("opacity", rot1_1);
          leaver_2.setAttribute("opacity", rot2_1);
        }

        if (aniPoints > 175 && !endAnimation) {
          endAnimation = true;
          aniPoints = 0;
          fast_ = 50;
          fast_2 = 50;
        }
      }
      let rot1_1 = 0,
        rot1_2 = 1,
        rot1_3 = 0,
        rot2_1 = 0,
        rot2_2 = 1,
        rot2_3 = 0,
        fast_ = 50,
        fast_2 = 50,
        aniPoints = 0,
        endAnimation = !1,
        leaver_1 = document.querySelectorAll("g")[7],
        leaver_2 = document.querySelectorAll("g")[8],
        Interval = null;
      leaver_1.setAttribute("opacity", 0);
      leaver_2.setAttribute("opacity", 0);
      startAnimation();
    });
  },
};
</script>
